import { useToast } from '@urbanx/agx.ui-components2'
import { NswContractStage, QldContractStage } from '@urbanx/agx-ui-components'
import useSelectedContract from './useSelectedContract'
import {
  ContractActionRequestContractAction,
  useInvalidateUseStaffGetContract,
  usePerformContractAction,
} from '@urbanx/agx.campaigns.client'

const useSelectedContractStage = (): {
  contractStage?: QldContractStage | NswContractStage
  performContractAction: (action: ContractActionRequestContractAction) => void
} => {
  const { campaignId, contract } = useSelectedContract()
  const invalidateContract = useInvalidateUseStaffGetContract()
  const { pushToast } = useToast()

  const { performContractAction: performContractActionValue } =
    usePerformContractAction({
      onSuccess: async () => {
        if (contract?.contractId) await invalidateContract(contract.contractId)
      },
      onError: (error) => {
        console.error('Error performing contract action:', error)
        pushToast({
          message: 'Error updating contract status',
          type: 'error',
        })
      },
    })

  const performContractAction = (action: ContractActionRequestContractAction) => {
    if (!campaignId || !contract?.contractId) return

    performContractActionValue({
      campaignId,
      contractId: contract.contractId,
      contractAction: action,
    })
  }

  return {
    contractStage: contract?.contractStage,
    performContractAction: performContractAction,
  }
}

export default useSelectedContractStage
